import { debounce } from '@src/utils/helper.js'

const waitTime = 18;
const waitHalfSec = 500;
// Page Scroll
let distanceScrolled = -1
let distanceThreshold = [
    { threshold: 0, value: 'Baseline', sent: false },
    { threshold: 25, value: '25%', sent: false },
    { threshold: 50, value: '50%', sent: false },
    { threshold: 75, value: '75%', sent: false },
    { threshold: 100, value: '100%', sent: false },
]

const scrollDepth = () => {
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    let progress = Math.round((scrollTop / (document.body.scrollHeight - window.innerHeight)) * 100);

    if (isNaN(progress)) progress = 0;

    if (progress > distanceScrolled) {
        distanceScrolled = progress;

        for (const item of distanceThreshold) {
            const { sent, threshold, value } = item;

            if (!sent && progress >= threshold && 'dataLayer' in window) {
                window.dataLayer.push({
                event: 'gatsbyScroll',
                gatsbyScrollDistance: value
                });
                item.sent = true;
            }
        }
    }
}

const scrollListener = debounce(scrollDepth, waitTime);

// ISI Scroll
let distanceScrolledIsi = -1
let distanceThresholdIsi = [
    { threshold: 0, value: 'Baseline', sent: false },
    { threshold: 25, value: '25%', sent: false },
    { threshold: 50, value: '50%', sent: false },
    { threshold: 75, value: '75%', sent: false },
    { threshold: 100, value: '100%', sent: false },
]

const scrollDepthIsi = () => {
    const sidebarIsi = document.querySelector(GTM.getSidebarISISelector())
    const scrollTop = sidebarIsi?.scrollTop

    let progress = Math.round(
        (scrollTop / (sidebarIsi.scrollHeight - sidebarIsi.clientHeight)) * 100
    )
    if (isNaN(progress)) progress = 0

    if (progress > distanceScrolledIsi) {
        distanceScrolledIsi = progress

        for (const item of distanceThresholdIsi) {
            const { sent, threshold, value } = item;

            if (!sent && progress >= threshold && 'dataLayer' in window) {
                window.dataLayer.push({
                event: 'isiScroll',
                isiScrollDistance: value,
                });
                item.sent = true;
            }
        }

    }
}

const scrollListenerIsi = debounce(scrollDepthIsi, waitTime);

let sczTimer20Sec;
let timer = null;
let counter = 0;

const GTM = {
    handleRoute: () => {
        const sczTimer = () => {
            if (window.location.pathname.includes("schizophrenia")) {
                if (!sczTimer20Sec) {
                    sczTimer20Sec = setTimeout(() => {
                        window.dataLayer.push({
                            event: "schizophrenia20Seconds",
                        })
                    }, 2*10000)
                }
            } else {
                clearTimeout(sczTimer20Sec)
            }
        }

        const clearTimer = () => {
            clearInterval(timer);
            timer = null;
            counter = 0;
        }

        clearTimer();

        timer = setInterval(() => {
            if ("dataLayer" in window && "google_tag_manager" in window) {
                clearTimer();
                sczTimer();
            } else if (counter === 60) {
                clearTimer();
            } else {
                // no-action needed
            }

            counter++
        }, waitHalfSec);
    },
    init: () => {
        const interval = setInterval(() => {
            if ("dataLayer" in window && "google_tag_manager" in window) {
                window.dataLayer.push({ event: "gatsby-route-change" })
                clearInterval(interval)
            }
        }, 100)
        scrollDepth()
        document.addEventListener("scroll", scrollListener)
    },
    getSidebarISISelector: () => {
        return window.location.pathname.includes("schizophrenia")
            ? "aside section"
            : "aside"
    },
    initIsi: () => {
        scrollDepthIsi()
        const sidebarIsi = document.querySelector(GTM.getSidebarISISelector())
        if (sidebarIsi) {
            sidebarIsi.addEventListener("scroll", scrollListenerIsi)
        }
    },
    handleCheckbox: (val, url) => {
        if ("dataLayer" in window) {
            window.dataLayer.push({ event: "checkboxChange", checkboxChecked: val ? 'Checked' : 'Unchecked', checkboxUrl: url })
        }
    },
    pushToDataLayer: (event, eventAction, eventLabel, additionalData = {}) => {
        if (typeof window !== "undefined") {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event, eventAction, eventLabel, ...additionalData });
        }
    },
    reset: () => {
        distanceScrolled = -1
        distanceThreshold.forEach(threshold => (threshold.sent = false))
        distanceScrolledIsi = -1
        distanceThresholdIsi.forEach(threshold => (threshold.sent = false))
    },
    downloadDDG: fileName => {
        if ("dataLayer" in window) {
            window.dataLayer.push({ event: "ddgDownload", ddgFileName: fileName })
        }
    }
}

export default GTM
